// @flow
import * as React from 'react';
import {
  useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation
} from '../../../../../../shared';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../../../../app/theme';
import { MenuItem } from '@mui/material';


export const ArAgentConfirmationToggleReBookOption = ({id, onClick}: {id: string, onClick: () => void}) => {
  const [request] = useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation({
    variables: {id}
  })
  const confirm = useConfirm(theme);

  const handleClick = () => confirm({
    title: 'Confirmation',
    content: 'Do you want to re-book this appointment to another time?',
    okButtonTitle: 'Yes',
    cancelButtonTitle: 'No',
    width: 500
  }).then(val => {
    if (val) {
      request();
    }
  })

  return (
    <MenuItem onClick={() => {
      onClick();
      handleClick();
    }}>Reschedule to another time</MenuItem>
  );
};
